var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterbg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 746,
    height: 216,
    viewBox: "0 0 746 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.517 129.738L27.0237 216.232L113.517 302.726L200.011 216.232L113.517 129.738Z",
    fill: "#667085"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0s"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2788 172.988L27.032 216.235L70.2788 259.482L113.526 216.235L70.2788 172.988Z",
    fill: "#98A2B3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.2s"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2468 172.984L0 216.231L43.2469 259.478L86.4937 216.231L43.2468 172.984Z",
    fill: "#D0D5DD"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.4s"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M632.481 302.724L718.975 216.23L632.481 129.737L545.988 216.23L632.481 302.724Z",
    fill: "#98A2B3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.6s"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M416.239 432.469L632.473 216.234L416.239 0.000119424L200.005 216.234L416.239 432.469Z",
    fill: "#D0D5DD"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "0.8s"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M329.746 432.469L545.98 216.234L329.746 0.000119424L113.511 216.234L329.746 432.469Z",
    fill: "#667085"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1s"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M243.252 345.975L372.992 216.235L243.252 86.4941L113.511 216.235L243.252 345.975Z",
    fill: "#98A2B3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.2s"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.507 302.725L373.001 216.231L286.507 129.738L200.014 216.231L286.507 302.725Z",
    fill: "#475467"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.4s"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M416.239 345.975L545.979 216.234L416.239 86.4939L286.498 216.234L416.239 345.975Z",
    fill: "#475467"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.6s"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M373 302.725L459.494 216.231L373 129.737L286.507 216.231L373 302.725Z",
    fill: "#EAECF0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "1.8s"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M416.239 259.481L459.486 216.234L416.239 172.988L372.992 216.234L416.239 259.481Z",
    fill: "#667085"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2s"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M675.72 259.481L718.967 216.234L675.72 172.987L632.473 216.234L675.72 259.481Z",
    fill: "#D0D5DD"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.2s"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M702.753 259.477L746 216.23L702.753 172.983L659.506 216.23L702.753 259.477Z",
    fill: "#475467"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "6s",
    repeatCount: "indefinite",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    begin: "2.4s"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterbg);
export default __webpack_public_path__ + "static/media/footerbg.182352fce1208d927215d5fbe83c5632.svg";
export { ForwardRef as ReactComponent };